import { render, staticRenderFns } from "./CommonSortSentence.vue?vue&type=template&id=4b85b726&scoped=true"
import script from "./CommonSortSentence.vue?vue&type=script&lang=js"
export * from "./CommonSortSentence.vue?vue&type=script&lang=js"
import style0 from "./CommonSortSentence.vue?vue&type=style&index=0&id=4b85b726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b85b726",
  null
  
)

export default component.exports